import Grid from '@mui/material/GridLegacy';
import { useContext } from 'react';

import { SeequentLogo } from '../../assets/SeequentLogo';
import { SEEQUENT_LOGO_WIDTH, SEEQUENT_LOGO_HEIGHT } from '../../constants';
import type { LoginHandlerContextState } from '../loginHandler/LoginContext';
import { LoginContext } from '../loginHandler/LoginContext';
import { useStyles } from './Background.styles';

export function Background({ children }: React.PropsWithChildren) {
    const { imageList } = useContext<LoginHandlerContextState>(LoginContext);

    const { classes } = useStyles({ imageList });

    return (
        <Grid
            className={classes.background}
            container
            direction="column"
            alignItems="center"
            automation-id="background-root"
        >
            <Grid item className={classes.topPlaceholder} />
            <Grid className={classes.box} item xs={12}>
                <header className={classes.headerBlock}>
                    <h2 className={classes.header}>
                        <SeequentLogo
                            style={{
                                display: 'block',
                                width: SEEQUENT_LOGO_WIDTH,
                                height: SEEQUENT_LOGO_HEIGHT,
                            }}
                        />
                    </h2>
                </header>
                <Grid
                    container
                    className={classes.body}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    {children}
                </Grid>
            </Grid>
        </Grid>
    );
}
